type CardVariant = 'home' | 'merch';

interface ProductCardProps {
  imageUrl: string;
  productName: string;
  description: string;
  onClick?: () => void;
  variant?: CardVariant;
}

export const ProductCard = ({ 
  imageUrl, 
  productName, 
  description, 
  onClick,
  variant = 'home'
}: ProductCardProps) => {
  
  const clipPathStyle = {
    clipPath: 'polygon(-20px 0,  100% 0,  100% 100%,  0 100%,  0 -20px)'
  };

  // 3. Lógica de Altura baseada na variante
  // Home: Altura fixa para todos os cards, baseada no Revo Hook (maior texto)
  // Merch: h-full para preencher o Swiper
  const heightClass = variant === 'home' 
    ? 'h-[280px] sm:h-[300px] md:h-[340px] lg:h-[400px]'
    : 'h-full';

  const paddingClass = variant === 'home' 
    ? 'p-4 pt-12' 
    : 'p-8 pt-16';

  return (
    <div 
      className={`w-full max-w-sm mx-auto flex flex-col items-center ${onClick ? 'cursor-pointer' : ''} h-full`}
      onClick={onClick}
    >
      {/* Container da Imagem */}
      <div className="w-[250px] h-[200px] md:w-[400px] md:h-[350px] relative z-10 flex-shrink-0">
        <img 
          src={imageUrl} 
          alt={productName} 
          className="w-full h-full object-scale-down object-center drop-shadow-xl"
        />
      </div>

      {/* Container do Texto (Caixa com Borda) */}
      <div className="relative w-full -mt-16 flex-grow flex flex-col">
        <div 
          className={`
            relative bg-transparent border-4 border-white text-white 
            flex flex-col justify-between items-center
            ${heightClass} 
            ${paddingClass}
          `}
          style={clipPathStyle}
        >
          {/* Decoração Canto Superior Esquerdo */}
          <div
            className="pointer-events-none absolute top-0 left-0"
            style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(0 0, 100% 0, 0 100%)' }}
          />
          
          {/* Decoração Canto Inferior Direito */}
          <div
            className="pointer-events-none absolute bottom-0 right-0"
            style={{ width: 20, height: 20, backgroundColor: 'white', clipPath: 'polygon(100% 0, 100% 100%, 0 100%)' }}
          />

          {/* Conteúdo */}
          <div className="w-full flex flex-col items-center justify-start h-full">
            <h3 className="font-displayed text-white text-2xl md:text-3xl uppercase text-center mb-2">
              {productName}
            </h3>
            
            <p className={`font-orator font-bold text-orangicide text-center text-base md:text-lg ${variant === 'merch' ? 'mt-auto' : 'mt-2'}`}>
              {description}
            </p>
            
            {/* Espaço flexível para empurrar o conteúdo para cima e deixar espaço vazio embaixo */}
            {variant === 'home' && <div className="flex-grow"></div>}
          </div>
        </div>
      </div>
    </div>
  );
};